// extracted by mini-css-extract-plugin
export default {"Container":"container_Container__YapV6","FullScreen":"container_FullScreen__rLT1w","FullWidth":"container_FullWidth__QLWXx"};